export default __webpack_public_path__ + "static/media/searchRegion.a23fb59a.svg";